module.exports = __webpack_public_path__ + "static/media/8cb5d6bca5a6cde3753bc60aa7f7-1568855.6784866d.jpg";